<template>
  <div :id="chartId" class="apexchart-container">
    <div ref="chartContainer"></div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts';

export default {
  name: 'BarchartApex',
  props: {
    chartId: {
      type: String,
      default: 'barchart_apex',
    },
    series: {
      type: Array,
      required: true,
      default: () => [],
    },
    categories: {
      type: Array,
      required: true,
      default: () => [],
    },
    color_stacks: {
      type: Array,
      required: false,
      default: () => ['#8D25F6', '#3357FF', '#33FF57', '#FF5733'],
    },
    title: {
      type: Object,
      default: () => ({}),
    },
    title_style: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    series: {
      deep: true,
      handler(newSeries) {
        if (this.chart) {
          this.chart.updateSeries(newSeries);
          this.chart.updateOptions(this.generateChartOption(), false, false);
        }
      },
    },
    categories(newCategories) {
      if (this.chart) {
        const updatedOptions = this.generateChartOption();
        updatedOptions.xaxis.categories = newCategories;
        this.chart.updateOptions(updatedOptions, false, false);
      }
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      const chartOptions = {
        ...this.generateChartOption(),
        series: this.series,
      };
      this.chart = new ApexCharts(this.$refs.chartContainer, chartOptions);
      this.chart.render();
    },
    generateChartOption() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          // stackType: '100%',
          toolbar: {
            show: false,
          },
          redrawOnWindowResize: false,
        },
        tooltip: {
          enabled: true,
        },
        dataLabels: {
          enabled: true,
          formatter: val => `${val}`,
          style: {
            fontSize: '12px',
            colors: ['#fff'],
          },
        },
        xaxis: {
          categories: this.categories,
        },
        fill: {
          opacity: 1,
          colors: [
            // '#8D25F6', '#3357FF', '#33FF57', "#FF5733"
            ...this.color_stacks,
          ],
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          layout: 'horizontal',
          offsetX: 0,
          offsetY: 0,
        },
        title: {
          text: '',
          align: 'center',
          margin: 12,
          ...this.title,
          style: {
            fontSize: '20px',
            fontWeight: '600',
            fontFamily: 'Figtree, Arial, sans-serif',
            color: '#1F1F1F',
            ...this.title_style,
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.apexchart-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}
</style>
